import { DynamicModule, Module, Global } from '@nestjs/common';
import { HttpModule, HttpService } from '@nestjs/axios';
import { AsyncConfiguration, Configuration } from './configuration';

import { BroadcastApi } from './api/broadcast.service';
import { ChatApi } from './api/chat.service';
import { EventsApi } from './api/events.service';
import { HealthApi } from './api/health.service';
import { RecipientListApi } from './api/recipientList.service';
import { TemplateApi } from './api/template.service';

@Global()
@Module({
  exports: [
    BroadcastApi,
    ChatApi,
    EventsApi,
    HealthApi,
    RecipientListApi,
    TemplateApi,
  ],
})
export class ApiModule {
  static forRootAsync(options: AsyncConfiguration): DynamicModule {

    const optionsProvider = {
      provide: Configuration,
      useFactory: options.useFactory,
      inject: options.inject,
    };

    const httpModule = HttpModule.registerAsync({
      useFactory: (options: Configuration) => ({
        httpsAgent: options.httpsAgent,
        httpAgent: options.httpAgent,
      }),
      extraProviders: [
        ...(options.providers || []),
        optionsProvider,
      ],
      inject: [ Configuration ],
      imports: [ ...(options.imports || []) ]
    });

    return {
      module: ApiModule,
      providers: [
        ...(options.providers || []),
        optionsProvider,

        {
          provide: BroadcastApi,
          useClass: BroadcastApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: ChatApi,
          useClass: ChatApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: EventsApi,
          useClass: EventsApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: HealthApi,
          useClass: HealthApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: RecipientListApi,
          useClass: RecipientListApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: TemplateApi,
          useClass: TemplateApi,
          ...(options.scope && { scope: options.scope }),
        },

      ],
      imports: [
        ...(options.imports || []),
        httpModule,
      ]
    };
  }

  constructor( httpService: HttpService) { }
}
